var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "section",
    {
      ref: "floatLayer",
      staticClass: "vn-order__container",
      class: [
        { "vn-order__container--active": _vm.showProductsHolder },
        { "vn-order__container--hidden": _vm.isHidden },
      ],
      on: {
        click: function ($event) {
          return _vm.init()
        },
      },
    },
    [
      _c(
        "div",
        {
          staticClass: "vn-order",
          on: {
            click: function ($event) {
              $event.stopPropagation()
            },
          },
        },
        [
          _c("div", { staticClass: "vn-order__frame" }, [
            _vm.showProductsHolder
              ? _c("div", { staticClass: "vn-order__select" }, [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.isOpenProductSelector,
                        expression: "isOpenProductSelector",
                      },
                    ],
                    staticClass: "vn-order__trigger a11y",
                    attrs: { type: "checkbox", id: "select-prod" },
                    domProps: {
                      checked: Array.isArray(_vm.isOpenProductSelector)
                        ? _vm._i(_vm.isOpenProductSelector, null) > -1
                        : _vm.isOpenProductSelector,
                    },
                    on: {
                      change: function ($event) {
                        var $$a = _vm.isOpenProductSelector,
                          $$el = $event.target,
                          $$c = $$el.checked ? true : false
                        if (Array.isArray($$a)) {
                          var $$v = null,
                            $$i = _vm._i($$a, $$v)
                          if ($$el.checked) {
                            $$i < 0 &&
                              (_vm.isOpenProductSelector = $$a.concat([$$v]))
                          } else {
                            $$i > -1 &&
                              (_vm.isOpenProductSelector = $$a
                                .slice(0, $$i)
                                .concat($$a.slice($$i + 1)))
                          }
                        } else {
                          _vm.isOpenProductSelector = $$c
                        }
                      },
                    },
                  }),
                  _vm._v(" "),
                  _c(
                    "label",
                    {
                      staticClass: "vn-order__holder",
                      class: { "vn-order__holder--active": _vm.isSelected },
                      attrs: { for: "select-prod" },
                    },
                    [
                      _vm._v(
                        "\n          " + _vm._s(_vm.selectedProductTitle) + " "
                      ),
                      _vm.selectedProductPrice
                        ? _c("i", { staticClass: "price" }, [
                            _vm._v(_vm._s(_vm.selectedProductPrice) + " 원"),
                          ])
                        : _vm._e(),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "ul",
                    { staticClass: "vn-order__list" },
                    _vm._l(_vm.products, function (product, index) {
                      return _c("li", { key: index }, [
                        _c("input", {
                          staticClass: "vn-order__item a11y",
                          attrs: {
                            type: "radio",
                            name: "select-prod",
                            id: "select-prod-" + index,
                          },
                          on: {
                            click: function ($event) {
                              return _vm.selectProduct(index)
                            },
                          },
                        }),
                        _vm._v(" "),
                        _c(
                          "label",
                          {
                            staticClass: "vn-order__item--label",
                            attrs: { for: "select-prod-" + index },
                          },
                          [
                            _vm._v(
                              "\n              " +
                                _vm._s(product.title) +
                                "\n              "
                            ),
                            _c("i", { staticClass: "vn-order__item--price" }, [
                              _vm._v(
                                _vm._s(_vm.renderPrice(product.salePrice)) +
                                  " 원"
                              ),
                            ]),
                          ]
                        ),
                      ])
                    }),
                    0
                  ),
                ])
              : _vm._e(),
            _vm._v(" "),
            _c("div", { staticClass: "vn-order__prod" }, [
              _vm.promotionDDay
                ? _c("i", { staticClass: "vn-order__prod__label" }, [
                    _vm._v(_vm._s(_vm.promotionDDay)),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _c("h2", { staticClass: "vn-order__prod__title" }, [
                _vm._v("\n          " + _vm._s(_vm.promotionTitle) + " "),
                _c("span", { staticClass: "sub" }, [
                  _vm._v(_vm._s(_vm.promotionDescription)),
                ]),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "vn-order__func" }, [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.canGoForward,
                    expression: "canGoForward",
                  },
                ],
                staticClass: "vn-order__switch a11y",
                attrs: { type: "checkbox", id: "select-switch" },
                domProps: {
                  checked: Array.isArray(_vm.canGoForward)
                    ? _vm._i(_vm.canGoForward, null) > -1
                    : _vm.canGoForward,
                },
                on: {
                  change: function ($event) {
                    var $$a = _vm.canGoForward,
                      $$el = $event.target,
                      $$c = $$el.checked ? true : false
                    if (Array.isArray($$a)) {
                      var $$v = null,
                        $$i = _vm._i($$a, $$v)
                      if ($$el.checked) {
                        $$i < 0 && (_vm.canGoForward = $$a.concat([$$v]))
                      } else {
                        $$i > -1 &&
                          (_vm.canGoForward = $$a
                            .slice(0, $$i)
                            .concat($$a.slice($$i + 1)))
                      }
                    } else {
                      _vm.canGoForward = $$c
                    }
                  },
                },
              }),
              _vm._v(" "),
              _c(
                "label",
                {
                  staticClass: "vn-order__switcher btn btn--md btn--wide",
                  attrs: { for: "select-switch" },
                },
                [_vm._v("수강권 선택하기")]
              ),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "vn-order__btn btn btn--md btn--wide",
                  attrs: { type: "button", disabled: !_vm.isSelected },
                  on: { click: _vm.purchase },
                },
                [
                  _vm._v(
                    "\n          " + _vm._s(_vm.buttonLabel) + "\n        "
                  ),
                ]
              ),
            ]),
          ]),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }